import { MaterialTypeSchema } from "./recycling.type";


export enum ContainerStatus {
  READY_FOR_PICKUP = "ready_for_pickup",
  MAINTENANCE = "maintenance",
  AWAITING_PICKUP = "awaiting_pickup",
  EMPTY = "empty",
  PENDING = "pending",
  INACTIVE = "inactive",
}

export interface ContainerSchema {
  id: string;

  device_id: string;
  material_type_id: string;
  material_type: MaterialTypeSchema;
  status: ContainerStatus;
  longitude?: number;
  latitude?: number;
  buffer?: number;
  collection_site_id?: string;

  height?: number;
  temperature?: number;
  angle?: number;
  full_alarm?: boolean;
  fire_alarm?: boolean;
  tilt_alarm?: boolean;
  battery_alarm?: boolean;
  volt?: number;
  rsrp?: number;
  frame_counter?: number;
  fill_level?: number;
  capacity?: number;

  data: Record<string, any>;

  organization_id: string;
  created_at: string;
  updated_at: string;
}

export interface ContainerRequest {
  device_id: string;
  material_type_id: string;
  status?: ContainerStatus;
  longitude?: number;
  latitude?: number;
  buffer?: number;
  collection_site_id?: string;
  data?: Record<string, any>;
  organization_id: string;
  fill_level?: number; 
}

export interface UpdateContainerRequest {
  device_id?: string;
  material_type_id?: string;
  status?: ContainerStatus;
  longitude?: number;
  latitude?: number;
  buffer?: number;
  collection_site_id?: string;
  height?: number;
  temperature?: number;
  angle?: number;
  full_alarm?: boolean;
  fire_alarm?: boolean;
  tilt_alarm?: boolean;
  battery_alarm?: boolean;
  volt?: number;
  rsrp?: number;
  frame_counter?: number;

  data?: Record<string, any>;
  organization_id?: string;
}

export interface ContainerQueryParams {
  organization_id: string;
  material_type_id?: string;
  status?: ContainerStatus;
  /** If supported by API, limits results to containers at this collection site */
  collection_site_id?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface PaginatedContainerResponse {
  containers: ContainerSchema[];
  total: number;
}
